var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { io } from 'socket.io-client';
import AudioQueueManager from './audio/audio-queue-manager';
import { PersonaError } from './error';
import { EventEmitter } from './event-emitter';
import PersonaService from './persona-service';
import { generateUUID } from './utils';
var SINDARIN_URL = 'https://api.prod.centralus.az.sindarin.tech';
var LEVELS = {
    INFO: 'info',
    ERROR: 'error',
    WARN: 'warn',
};
var PersonaClient = (function (_super) {
    __extends(PersonaClient, _super);
    function PersonaClient(apiKey) {
        var _this = _super.call(this) || this;
        _this.socket = null;
        _this.messages = [];
        _this.isPaused = true;
        _this.handleInitResponse = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var statusCode = _b.statusCode, res = _b.res;
            return __generator(this, function (_c) {
                if (statusCode === 201) {
                    if (!res.id) {
                        if (res === null || res === void 0 ? void 0 : res.errors) {
                            throw new PersonaError('SOCKET', JSON.stringify(res.errors, null, 2));
                        }
                        throw new PersonaError('SOCKET', "Failed to create conversation with message: ".concat(JSON.stringify(res)));
                    }
                    this.conversationId = res.id;
                    this._registerAudioQueueListeners();
                    this.registerSocketEvents();
                    this.emit('ready');
                }
                else {
                    this.emit('error', new PersonaError('SOCKET', 'Failed to initiate socket'));
                }
                return [2];
            });
        }); };
        _this.socket = null;
        _this.apiKey = apiKey;
        _this.messages = [];
        _this.service = new PersonaService(apiKey);
        return _this;
    }
    PersonaClient.prototype.configure = function (config) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.config = {
                userId: config.userId || '',
                personaName: config.personaName,
                personaId: config.personaId,
                details: config.details,
                personaConfig: config.personaConfig,
                metadata: config.metadata || {},
                options: config.options || {
                    shouldNotSaveConversation: false,
                    debugMode: false,
                    streamTranscripts: false,
                },
            };
            resolve();
        });
    };
    PersonaClient.prototype.init = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1, error_2, error_3, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 12, , 13]);
                        this.messages = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, this.configure(config)];
                    case 2:
                        _a.sent();
                        return [4, this.setupAudioQueManager()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        throw error_1;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4, this.setupSocket()];
                    case 6:
                        _a.sent();
                        return [3, 8];
                    case 7:
                        error_2 = _a.sent();
                        throw error_2;
                    case 8:
                        _a.trys.push([8, 10, , 11]);
                        return [4, this.audioQueueManager.startChatting()];
                    case 9:
                        _a.sent();
                        return [3, 11];
                    case 10:
                        error_3 = _a.sent();
                        throw error_3;
                    case 11: return [3, 13];
                    case 12:
                        error_4 = _a.sent();
                        throw error_4;
                    case 13: return [2];
                }
            });
        });
    };
    PersonaClient.prototype.setupAudioQueManager = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.audioQueueManager = new AudioQueueManager();
                        return [4, this.audioQueueManager.initializeChat()];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_5 = _a.sent();
                        this.audioQueueManager = null;
                        throw error_5;
                    case 3: return [2];
                }
            });
        });
    };
    PersonaClient.prototype.setupSocket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_6;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, new Promise(function (resolve, reject) {
                                var _a = _this.config, personaName = _a.personaName, personaConfig = _a.personaConfig, personaId = _a.personaId, details = _a.details, userId = _a.userId, metadata = _a.metadata, options = _a.options;
                                _this.socket = io("".concat(SINDARIN_URL, "/"), {
                                    reconnection: false,
                                    autoConnect: false,
                                    transports: ['websocket'],
                                    query: { apiKey: _this.apiKey },
                                });
                                _this.socket.connect();
                                _this.socket.on('connect_error', function (error) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                this.emit('connect_error', new PersonaError('SOCKET', error.message));
                                                return [4, this.end()];
                                            case 1:
                                                _a.sent();
                                                reject(new PersonaError('SOCKET', error.message));
                                                return [2];
                                        }
                                    });
                                }); });
                                _this.socket.on('error', function (error) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                this.emit('error', new PersonaError('SOCKET', error));
                                                reject(new PersonaError('SOCKET', error));
                                                return [4, this.end()];
                                            case 1:
                                                _a.sent();
                                                return [2];
                                        }
                                    });
                                }); });
                                _this.socket.on('init_response', function (res) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4, this.handleInitResponse(res)];
                                            case 1:
                                                _a.sent();
                                                resolve();
                                                return [2];
                                        }
                                    });
                                }); });
                                _this.socket.emit('init', {
                                    apiKey: _this.apiKey,
                                    personaName: personaName,
                                    personaId: personaId,
                                    details: details,
                                    userId: userId,
                                    metadata: metadata,
                                    personaConfig: personaConfig,
                                    inputAudioFormat: 'pcm',
                                    inputAudioSampleRate: _this.audioQueueManager.AudioRecorder.recordingSampleRate,
                                    outputAudioFormat: 'mp3',
                                    shouldNotSaveConversation: !!options.shouldNotSaveConversation,
                                    debugMode: !!options.debugMode,
                                    streamTranscripts: !!options.streamTranscripts,
                                });
                            })];
                    case 1:
                        _a.sent();
                        return [3, 3];
                    case 2:
                        error_6 = _a.sent();
                        throw error_6;
                    case 3: return [2];
                }
            });
        });
    };
    PersonaClient.prototype.registerSocketEvents = function () {
        var _this = this;
        if (!this.socket)
            return;
        this.socket.on('temporary_user_transcript', function (transcript) {
            var json = JSON.parse(transcript);
            var existingTempMessage = _this.messages.find(function (msg) { return msg.type === 'temporary_message' && msg.source === 'user'; });
            var existingFinalMessage = _this.messages.find(function (msg) {
                return msg.type === 'message' &&
                    msg.source === 'user' &&
                    msg.messageId === json.messageId;
            });
            var didNewTranscriptStartAfterOldTranscript = existingFinalMessage && json.start > existingFinalMessage.end - 200;
            if (existingFinalMessage) {
                if (!didNewTranscriptStartAfterOldTranscript) {
                    _this.messages = _this.messages.filter(function (msg) { return !(msg.source === 'user' && msg.messageId === json.messageId); });
                }
            }
            if (existingTempMessage) {
                existingTempMessage.content = json.message;
            }
            else {
                _this.messages.push({
                    source: 'user',
                    type: 'temporary_message',
                    messageId: json.messageId,
                    content: json.message,
                });
            }
            _this.emit('messages_update', _this.messages);
        });
        this.socket.on('final_user_transcript', function (transcript) {
            var json = JSON.parse(transcript);
            _this.messages = _this.messages.filter(function (msg) {
                return !(msg.source === 'user' &&
                    msg.type === 'temporary_message' &&
                    msg.messageId === json.messageId);
            });
            var existingMessage = _this.messages.find(function (msg) { return msg.source === 'user' && msg.messageId === json.messageId; });
            var didNewTranscriptStartAfterOldTranscript = existingMessage && json.start > existingMessage.end - 200;
            if (existingMessage) {
                if (!didNewTranscriptStartAfterOldTranscript) {
                    _this.messages = _this.messages.filter(function (msg) { return !(msg.source === 'user' && msg.messageId === json.messageId); });
                }
            }
            _this.messages.push({
                source: 'user',
                type: 'message',
                messageId: json.messageId,
                content: json.message,
                start: json.start,
                end: json.end,
            });
            _this.emit('messages_update', _this.messages);
        });
        this.socket.on('final_ai_transcript', function (transcript) {
            var json = JSON.parse(transcript);
            _this.messages.push({
                source: 'ai',
                type: 'message',
                messageId: json.messageId,
                content: json.message,
            });
            _this.emit('messages_update', _this.messages);
        });
        this.socket.on('reply_json', function (json) {
        });
        this.socket.on('conversation_trigger', function (triggerStr) {
            var json = JSON.parse(triggerStr);
            if (json.stop_playing) {
                _this.emit('ai_speech_stopped');
                if (_this.audioQueueManager) {
                    _this.audioQueueManager.stopAISpeech();
                }
            }
            else if (json.start_playing) {
                _this.emit('ai_speech_started');
                if (_this.audioQueueManager) {
                    _this.audioQueueManager.restartAISpeech();
                }
            }
            else if (json.speech_started) {
                _this.emit('user_speech_started');
            }
            else if (json.speech_ended) {
                _this.emit('user_speech_ended');
            }
        });
        this.socket.on('actions', function (jsonStr) {
            var json = JSON.parse(jsonStr);
            _this.messages.push({
                action: json,
            });
            _this.emit('action', json);
        });
        this.socket.on('state_updated', function (stateStr) {
            var json = JSON.parse(stateStr);
            _this.emit('state_updated', json);
        });
        this.socket.on('debug_event', function (events) {
            var json = JSON.parse(events);
            for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
                var event_1 = json_1[_i];
                _this.messages.push({
                    source: 'system',
                    level: event_1.level,
                    content: event_1.message,
                    category: event_1.category,
                    details: event_1.details,
                });
            }
            _this.emit('debug_event', json);
            _this.emit('messages_update', _this.messages);
        });
        this.socket.on('snapshot', function (events) {
            var json = JSON.parse(events);
            _this.emit('snapshot', json);
        });
        this.socket.on('disconnect', function () {
            _this.emit('disconnected');
        });
        this.socket.on('reply_chunk', function (chunk) { return __awaiter(_this, void 0, void 0, function () {
            var error_7;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.audioQueueManager) === null || _a === void 0 ? void 0 : _a.canAIAcceptNewInput())) return [3, 5];
                        this.audioQueueManager.enqueue(chunk);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4, this.audioQueueManager.playAudio()];
                    case 2:
                        _b.sent();
                        return [3, 4];
                    case 3:
                        error_7 = _b.sent();
                        throw error_7;
                    case 4: return [3, 6];
                    case 5:
                        console.log('****REPLY CHUNK REJECTED');
                        _b.label = 6;
                    case 6: return [2];
                }
            });
        }); });
        this.socket.on('reply_end', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2];
            });
        }); });
    };
    PersonaClient.prototype._registerAudioQueueListeners = function () {
        var _this = this;
        this.audioQueueManager.on('UserSpeechChunk', function (_a) {
            var fileBuffer = _a.fileBuffer, mimeType = _a.mimeType;
            if (_this.audioQueueManager) {
                _this.socket.emit('audio_chunk_continuous', {
                    conversationId: _this.conversationId,
                    fileBuffer: fileBuffer,
                });
            }
        });
        this.audioQueueManager.on('ai_speech_amplitude', function (amplitude) {
            _this.emit('ai_speech_amplitude', amplitude);
        });
    };
    PersonaClient.prototype.end = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.audioQueueManager) return [3, 2];
                        return [4, this.audioQueueManager.stopChatting()];
                    case 1:
                        _a.sent();
                        this.audioQueueManager = null;
                        _a.label = 2;
                    case 2:
                        if (this.socket) {
                            this.socket.disconnect();
                            this.socket = null;
                        }
                        if (this.config) {
                            this.config = null;
                        }
                        return [2];
                }
            });
        });
    };
    PersonaClient.prototype.pause = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.audioQueueManager) {
                            throw new PersonaError('PERSONA', 'Conversation not initialized');
                        }
                        this.messages.push({
                            messageId: generateUUID(),
                            source: 'system',
                            level: LEVELS.INFO,
                            content: 'Conversation paused.',
                        });
                        if (!this.audioQueueManager) return [3, 2];
                        return [4, this.audioQueueManager.stopChatting()];
                    case 1:
                        _a.sent();
                        this.audioQueueManager = null;
                        _a.label = 2;
                    case 2:
                        this.emit('messages_update', this.messages);
                        this.isPaused = true;
                        return [2];
                }
            });
        });
    };
    PersonaClient.prototype.resume = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.conversationId || !this.socket) {
                            throw new PersonaError('PERSONA', 'Conversation not initialized');
                        }
                        if (!this.isPaused) {
                            throw new PersonaError('PERSONA', 'Conversation in progress');
                        }
                        this.audioQueueManager = new AudioQueueManager();
                        return [4, this.audioQueueManager.initializeChat()];
                    case 1:
                        _a.sent();
                        this.audioQueueManager.startChatting();
                        this._registerAudioQueueListeners();
                        this.messages.push({
                            messageId: generateUUID(),
                            source: 'system',
                            level: LEVELS.INFO,
                            content: 'Conversation resumed.',
                        });
                        this.emit('messages_update', this.messages);
                        this.isPaused = false;
                        return [2];
                }
            });
        });
    };
    PersonaClient.prototype.updateState = function (state) {
        this.socket.emit('update_state', {
            apiKey: this.apiKey,
            conversationId: this.conversationId,
            newState: state,
        });
    };
    PersonaClient.prototype.sayText = function (text) {
        this.socket.emit('say_text', {
            conversationId: this.conversationId,
            text: text,
        });
    };
    PersonaClient.prototype.reactTo = function (text) {
        this.socket.emit('event_text', {
            conversationId: this.conversationId,
            text: text,
        });
    };
    return PersonaClient;
}(EventEmitter));
export default PersonaClient;
